import {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import {useRecoilValue} from "recoil";
import {providerState} from "../../../../atom/simpleCert";
import {routes} from "../../../../constants/routes";
import Page from "../../../components/Page";
import Button from "../../../components/Button";
import PushImage from "./PushImage";
import Guide from "./Guide";
import {optionState, trxState, useAlert} from "../../../../atom/common";
import axios from "axios";
import {commonProps} from "../Request";


interface responseProps extends commonProps {
    auth_token: string;
}

export default function Confirm() {
    const alert = useAlert();
    const provider = useRecoilValue(providerState);
    const {client_tx_id, server_tx_id} = useRecoilValue(trxState);
    const navigate = useNavigate();
    const formRef = useRef<HTMLFormElement>(null);
    const {callback_url, token} = useRecoilValue(optionState);

    useEffect(() => {
        if (!provider) navigate(routes.home);
    }, [provider, navigate]);

    if (!provider) return null;

    const confirm = () => {
        axios.post<responseProps>("/kiap-service/api/v1/result", {provider_id: provider, client_tx_id, server_tx_id},
            {headers: {Authorization: `Bearer ${token}`}}
        )
            .then(response => {
                const {code, message, auth_token} = response.data;
                if (formRef.current) {
                    formRef.current.auth_token.value = auth_token;
                    formRef.current.code.value = code;
                    formRef.current.message.value = message;
                    formRef.current.submit();
                }
            })
            .catch(error => {
                const {code, message} = error.response.data;
                alert(code, message)
            })
    };

    const prev = () => {
        navigate(routes.simpleCert.request);
    };

    return (
        <Page>
            <Page.Header></Page.Header>
            <Page.Content>
                <Page.Title title="인증을 진행하고 있습니다"/>
                <PushImage/>
                <Guide/>
                <Button confirm={confirm} prev={prev}> 인증 완료 </Button>
                <form action={callback_url} ref={formRef} style={{display: 'none'}} method={"post"}>
                    <input name={"provider_id"} value={provider} readOnly={true}/>
                    <input name={"client_tx_id"} value={client_tx_id} readOnly={true}/>
                    <input name={"server_tx_id"} value={server_tx_id} readOnly={true}/>
                    <input name={"access_token"} value={token} readOnly={true}/>
                    <input name={"code"}/>
                    <input name={"message"}/>
                    <input name={"auth_token"}/>
                </form>
            </Page.Content>
        </Page>
    );
}